// Дзеркало Prisma enum CalendarScope. Область дії періоду календаря (D8).
// Значення ідентичні apps/api/prisma/schema.prisma (перевіряє test/enums.spec.ts). Підписи — лише тут.
export const CalendarScope = {
    ALL: 'ALL',
    FACULTY: 'FACULTY',
    PROGRAM: 'PROGRAM',
    COURSE: 'COURSE',
};
/** Значення в порядку оголошення в схемі. */
export const CALENDAR_SCOPE_VALUES = ['ALL', 'FACULTY', 'PROGRAM', 'COURSE'];
export const CALENDAR_SCOPE_LABELS = {
    ALL: 'Увесь університет',
    FACULTY: 'Факультет',
    PROGRAM: 'Освітня програма',
    COURSE: 'Курс',
};
//# sourceMappingURL=calendar-scope.js.map